import * as React from "react";
import Tab from "../components/common/Tab/Tab";
import TabItem from "../components/common/Tab/TabItem";
import { ezsServiceIds } from "../config/UserServicesList";
import { useAreServicesActive } from "../util/CommonServices";
import { useTranslation } from "react-i18next";

const SupportTab: React.FunctionComponent<{ selectedTab: string }> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const breachActiveServices = useAreServicesActive([ezsServiceIds.businessBreachFulfillmentSupport]);

    const IncidenceActiveServices = useAreServicesActive([ezsServiceIds.businessIncidentResponseForensics]);

    return (
        <Tab tabId="identity-vault-tabs">
            <TabItem title={tLang("supportSection.generalSupportWidget.titleButtonText")} link="/support" tabNo="1" selectedTab={props.selectedTab} />
            {breachActiveServices && (
                <TabItem
                    title={tLang("supportSection.breachSupportWidget.titleButtonText")}
                    link="/support/breachSupport"
                    tabNo="2"
                    selectedTab={props.selectedTab}
                />
            )}
            {IncidenceActiveServices && (
                <TabItem
                    title={tLang("supportSection.incidentResponsetForensicsWidget.titleButtonText")}
                    link="/support/incidentResponse"
                    tabNo="3"
                    selectedTab={props.selectedTab}
                />
            )}
        </Tab>
    );
};

export default SupportTab;
